module.exports = __webpack_public_path__ + "media/images/front/varieties/FORTUNA-fc8bfbaea43869c139ca53c94b874b2c.jpg";